<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{form.main.qs_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.qs_prodcode" slot="qs_prodcode">
            <label class="weui-form-preview__label">{{customLabel.qs_prodcode || "物料编号"}}</label>
            <em class="weui-form-preview__value">{{form.main.qs_prodcode}}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_detail" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_detail}}</span>
          </div>
         
          <div class="weui-form-preview__item" v-if="form.main.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_spec" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_brand" slot="pr_brand" >
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_kind">
            <label class="weui-form-preview__label">{{customLabel.pr_kind || "物料类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_kind}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.qsd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          
          <div class="weui-form-preview__item" v-if="item.qsd_item" slot="qsd_item"> 
            <label class="weui-form-preview__label">{{customLabel.qsd_item || "检查项目"}}</label>
            <span class="weui-form-preview__value">{{item.qsd_item}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.qsd_method" slot="qsd_method">
            <label class="weui-form-preview__label">{{customLabel.qsd_method || "检查方法"}}</label>
            <span class="weui-form-preview__value">{{item.qsd_method}}</span>
          </div>
          <div class="weui-form-preview__item" slot="qsd_standard">
            <label class="weui-form-preview__label">{{customLabel.qsd_standard || "检查标准"}}</label>
            <span class="weui-form-preview__value">{{item.qsd_standard}}</span>
          </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "录入日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.createTime}}</span>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/qcset",
      caller:'FaiSet',
      xtype:'stock-faiset-formpanel'
    };
  }
};
</script>